module.exports = __webpack_public_path__ + "img/benefit4.88dacfb4.jpg";